
// import React, { useEffect, useState } from "react";
// import axios from "../../api/axiosAuth";

// import { useAuth } from "../../context/AuthContext";


// const API = (process.env.REACT_APP_API || "http://localhost:5001/api") + "/excusas";

// export default function ExcusasProfesor() {
//   const { token } = useAuth();
//   const [excusas, setExcusas] = useState([]);
//   const [filtros, setFiltros] = useState({ grado: "", grupo: "", periodo: "", anio: "" });
//   const [opts, setOpts] = useState({ grados: [], grupos: [], periodos: [], anios: [] });

//   const headers = { Authorization: `Bearer ${token}` };

//   useEffect(() => {
//     if (!token) return;
//     axios.get(`${API}/profesor/filters`, { headers })
//       .then(r => setOpts(r.data))
//       .catch(console.error);
//   }, [token]);

//   useEffect(() => {
//     if (!token) return;
//     axios.get(`${API}/profesor`, { headers, params: filtros })
//       .then(r => setExcusas(r.data || []))
//       .catch(console.error);
//   }, [token, filtros]);

//   return (
//     <div className="excusa-list">
//       <h2>📄 Excusas aprobadas</h2>

//       <div className="filtros">
//         {["grado","grupo","periodo","anio"].map(k => (
//           <select key={k} value={filtros[k]} onChange={e => setFiltros({ ...filtros, [k]: e.target.value })}>
//             <option value="">Todos {k}</option>
//             {(opts[k + "s"] || []).map(o => (
//               <option key={o.id || o} value={o.id || o}>{o.nombre || o}</option>
//             ))}
//           </select>
//         ))}
//       </div>

//       {excusas.length === 0 && <p>No hay excusas.</p>}

//       {excusas.length > 0 && (
//         <table className="tabla-excusas">
//           <thead>
//             <tr>
//               <th>Estudiante</th>
//               <th>Grado</th>
//               <th>Grupo</th>
//               <th>Motivo</th>
//               <th>Fechas</th>
//             </tr>
//           </thead>
//           <tbody>
//             {excusas.map(e => (
//               <tr key={e.id}>
//                 <td>{e.nombres_estudiante} {e.apellidos_estudiante}</td>
//                 <td>{e.grado}</td>
//                 <td>{e.grupo}</td>
//                 <td>{e.motivo}</td>
//                 <td>{e.fecha_inicio} → {e.fecha_fin}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       )}
//     </div>
//   );
// }


// ///
// import React, { useEffect, useState } from "react";
// import axios from "../../api/axiosAuth";
// import { useAuth } from "../../context/AuthContext";
// import "../../style/excusaprofesor.css";

// // const API = (process.env.REACT_APP_API || "http://localhost:5001/api") + "/excusas";

// const API = (process.env.REACT_APP_API || "http://3.236.217.225:5001/api") + "/excusas";

// export default function ExcusasProfesor() {
//   const { token } = useAuth();
//   const [excusas, setExcusas] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [filtros, setFiltros] = useState({ grado: "", grupo: "", periodo: "", anio: "" });
//   const [opts, setOpts] = useState({ grados: [], grupos: [], periodos: [], anios: [] });

//   const headers = token ? { Authorization: `Bearer ${token}` } : {};

//   const formatFecha = (fecha) => {
//     if (!fecha) return "-";
//     return new Date(fecha).toLocaleDateString("es-CO", {
//       year: "numeric", month: "2-digit", day: "2-digit",
//     });
//   };

//   const formatHoras = (horas) => {
//     if (!horas || horas.length === 0) return "Jornada completa";
//     try {
//       const parsed = typeof horas === "string" ? JSON.parse(horas) : horas;
//       if (Array.isArray(parsed)) {
//         return parsed.map((h) => 
//           typeof h === "string" ? h : `${h.hora_inicio?.slice(0, 5)} → ${h.hora_fin?.slice(0, 5)}`
//         ).join(", ");
//       }
//     } catch (err) { return "Ver detalle"; }
//     return String(horas);
//   };

//   const fetchFilters = async () => {
//     try {
//       const res = await axios.get(`${API}/profesor/filters`, { headers });
//       setOpts({
//         grados: res.data?.grados || [],
//         grupos: res.data?.grupos || [],
//         periodos: res.data?.periodos || [],
//         anios: res.data?.anios || [],
//       });
//     } catch (error) { console.error("❌ Error filtros:", error); }
//   };

//   const fetchExcusas = async () => {
//     setLoading(true);
//     try {
//       const res = await axios.get(`${API}/profesor`, { headers, params: filtros });
//       const data = (res.data || []).map((e) => ({
//         ...e,
//         horas: typeof e.horas === "string" ? JSON.parse(e.horas) : e.horas,
//       }));
//       setExcusas(data);
//     } catch (error) { console.error("❌ Error excusas:", error); }
//     finally { setLoading(false); }
//   };

//   useEffect(() => {
//     if (token) { fetchFilters(); fetchExcusas(); }
//   }, [token]);

//   // Recarga automática al cambiar filtros (opcional, si prefieres manual usa solo el botón)
//   useEffect(() => {
//     if (token) fetchExcusas();
//   }, [filtros.grado, filtros.grupo, filtros.periodo, filtros.anio]);

//   return (
//     <div className="excusa-list">
//       <h2><span role="img" aria-label="doc">📄</span> Excusas de mis estudiantes</h2>

//       <div className="filtros">
//         <select value={filtros.grado} onChange={(e) => setFiltros({ ...filtros, grado: e.target.value })}>
//           <option value="">Todos los grados</option>
//           {opts.grados.map((g) => <option key={g} value={g}>{g}</option>)}
//         </select>

//         <select value={filtros.grupo} onChange={(e) => setFiltros({ ...filtros, grupo: e.target.value })}>
//           <option value="">Todos los grupos</option>
//           {opts.grupos.map((g) => <option key={g} value={g}>{g}</option>)}
//         </select>

//         <select value={filtros.periodo} onChange={(e) => setFiltros({ ...filtros, periodo: e.target.value })}>
//           <option value="">Todos los periodos</option>
//           {opts.periodos.map((p) => <option key={p.id} value={p.id}>{p.nombre}</option>)}
//         </select>

//         <select value={filtros.anio} onChange={(e) => setFiltros({ ...filtros, anio: e.target.value })}>
//           <option value="">Todos los años</option>
//           {opts.anios.map((a) => <option key={a.id} value={a.id}>{a.anio}</option>)}
//         </select>

//         <button className="btn-buscar" onClick={fetchExcusas}>🔍 Buscar</button>
//         <button className="btn-reset" onClick={() => setFiltros({ grado: "", grupo: "", periodo: "", anio: "" })}>♻️ Reset</button>
//       </div>

//       <div className="tabla-container">
//         {loading ? (
//           <div style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>Cargando datos...</div>
//         ) : excusas.length === 0 ? (
//           <div style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>No se encontraron registros.</div>
//         ) : (
//           <table className="tabla-excusas">
//             <thead>
//               <tr>
//                 <th>Estudiante</th>
//                 <th>Grado</th>
//                 <th>Grupo</th>
//                 <th>Motivo</th>
//                 <th>Fechas</th>
//                 <th>Horas</th>
//                 <th>Estado</th>
//               </tr>
//             </thead>
//             <tbody>
//               {excusas.map((e, i) => (
//                 <tr key={e.id || i}>
//                   <td data-label="Estudiante"><strong>{e.nombres_estudiante} {e.apellidos_estudiante}</strong></td>
//                   <td data-label="Grado">{e.grado}</td>
//                   <td data-label="Grupo">{e.grupo}</td>
//                   <td data-label="Motivo">{e.motivo}</td>
//                   <td data-label="Fechas">{formatFecha(e.fecha_inicio)} - {formatFecha(e.fecha_fin)}</td>
//                   <td data-label="Horas">{formatHoras(e.horas)}</td>
//                   <td data-label="Estado">
//                     <span className={`estado ${e.estado?.toLowerCase()}`}>
//                       {e.estado}
//                     </span>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         )}
//       </div>
//     </div>
//   );
// }

//
import React, { useEffect, useState, useCallback } from "react";
import axios from "../../api/axiosAuth";
import { useAuth } from "../../context/AuthContext";
import "../../style/excusaprofesor.css";

/* =========================
   EXCUSAS PROFESOR (CLEAN)
========================= */

export default function ExcusasProfesor() {
  const { token } = useAuth();

  const [excusas, setExcusas] = useState([]);
  const [loading, setLoading] = useState(false);

  const [filtros, setFiltros] = useState({
    grado: "",
    grupo: "",
    periodo: "",
    anio: ""
  });

  const [opts, setOpts] = useState({
    grados: [],
    grupos: [],
    periodos: [],
    anios: []
  });

  /* =========================
     HELPERS SEGUROS
  ========================= */

  const safeArray = (data) => (Array.isArray(data) ? data : []);

  const formatFecha = (fecha) => {
    if (!fecha) return "-";
    return new Date(fecha).toLocaleDateString("es-CO", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
  };

  const formatHoras = (horas) => {
    if (!horas) return "Jornada completa";

    try {
      const parsed =
        typeof horas === "string" ? JSON.parse(horas) : horas;

      if (Array.isArray(parsed)) {
        return parsed
          .map((h) =>
            typeof h === "string"
              ? h
              : `${h.hora_inicio?.slice(0, 5)} → ${h.hora_fin?.slice(0, 5)}`
          )
          .join(", ");
      }
    } catch {
      return "Ver detalle";
    }

    return String(horas);
  };

  /* =========================
     FILTROS (BACKEND)
  ========================= */

  const fetchFilters = useCallback(async () => {
    try {
      const res = await axios.get("/excusas/profesor/filters");

      const data = res.data || {};

      setOpts({
        grados: safeArray(data.grados),
        grupos: safeArray(data.grupos),
        periodos: safeArray(data.periodos),
        anios: safeArray(data.anios)
      });
    } catch (err) {
      console.error("❌ Error filtros:", err);
    }
  }, []);

  /* =========================
     EXCUSAS
  ========================= */

  const fetchExcusas = useCallback(async () => {
    if (!token) return;

    setLoading(true);

    try {
      const res = await axios.get("/excusas/profesor", {
        params: filtros
      });

      const data = safeArray(res.data).map((e) => ({
        ...e,
        horas:
          typeof e.horas === "string"
            ? JSON.parse(e.horas)
            : e.horas
      }));

      setExcusas(data);
    } catch (err) {
      console.error("❌ Error excusas:", err);
      setExcusas([]);
    } finally {
      setLoading(false);
    }
  }, [token, filtros]);

  /* =========================
     INIT
  ========================= */

  useEffect(() => {
    if (!token) return;

    fetchFilters();
    fetchExcusas();
  }, [token, fetchFilters, fetchExcusas]);

  /* =========================
     AUTO REFRESH FILTROS
  ========================= */

  useEffect(() => {
    if (!token) return;
    fetchExcusas();
  }, [filtros.grado, filtros.grupo, filtros.periodo, filtros.anio]);

  /* =========================
     UI GUARD
  ========================= */

  if (!token) {
    return <div className="p-4">Acceso no autorizado</div>;
  }

  /* =========================
     UI
  ========================= */

  return (
    <div className="excusa-list">
      <h2>📄 Excusas de mis estudiantes</h2>

      {/* ================= FILTROS ================= */}
      <div className="filtros">

        <select
          value={filtros.grado}
          onChange={(e) =>
            setFiltros({ ...filtros, grado: e.target.value })
          }
        >
          <option value="">Todos los grados</option>
          {opts.grados.map((g) => (
            <option key={g} value={g}>{g}</option>
          ))}
        </select>

        <select
          value={filtros.grupo}
          onChange={(e) =>
            setFiltros({ ...filtros, grupo: e.target.value })
          }
        >
          <option value="">Todos los grupos</option>
          {opts.grupos.map((g) => (
            <option key={g} value={g}>{g}</option>
          ))}
        </select>

        <select
          value={filtros.periodo}
          onChange={(e) =>
            setFiltros({ ...filtros, periodo: e.target.value })
          }
        >
          <option value="">Todos los periodos</option>
          {opts.periodos.map((p) => (
            <option key={p.id} value={p.id}>
              {p.nombre}
            </option>
          ))}
        </select>

        <select
          value={filtros.anio}
          onChange={(e) =>
            setFiltros({ ...filtros, anio: e.target.value })
          }
        >
          <option value="">Todos los años</option>
          {opts.anios.map((a) => (
            <option key={a.id} value={a.id}>
              {a.anio}
            </option>
          ))}
        </select>

        <button onClick={fetchExcusas}>🔍 Buscar</button>

        <button
          onClick={() =>
            setFiltros({
              grado: "",
              grupo: "",
              periodo: "",
              anio: ""
            })
          }
        >
          ♻️ Reset
        </button>
      </div>

      {/* ================= TABLA ================= */}
      <div className="tabla-container">

        {loading ? (
          <div className="loading">⏳ Cargando...</div>
        ) : excusas.length === 0 ? (
          <div className="empty">No hay registros</div>
        ) : (
          <table className="tabla-excusas">
            <thead>
              <tr>
                <th>Estudiante</th>
                <th>Grado</th>
                <th>Grupo</th>
                <th>Motivo</th>
                <th>Fechas</th>
                <th>Horas</th>
                <th>Estado</th>
              </tr>
            </thead>

            <tbody>
              {excusas.map((e, i) => (
                <tr key={e.id || i}>
                  <td>
                    {e.nombres_estudiante} {e.apellidos_estudiante}
                  </td>
                  <td>{e.grado}</td>
                  <td>{e.grupo}</td>
                  <td>{e.motivo}</td>
                  <td>
                    {formatFecha(e.fecha_inicio)} -{" "}
                    {formatFecha(e.fecha_fin)}
                  </td>
                  <td>{formatHoras(e.horas)}</td>
                  <td>
                    <span className={`estado ${e.estado?.toLowerCase()}`}>
                      {e.estado}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>

          </table>
        )}
      </div>
    </div>
  );
}
